import HappyPlayIcon from '@stencil/icons/src/HappyPlayIcon/HappyPlayIcon';

import * as S from '../CaptivativeImagesGrid.styles';

const CaptivateCardImage = ({
  imgUrl = '',
  updateCarouselState = imageNo => {},
  imageNo = 1,
  isVideo = false,
  thumbnailUrl = '',
}) => {
  return isVideo ? (
    <S.VideoLandscapeImageWrapper
      playIconTop={'34%'}
      playIconLeft={'44%'}
      onClick={() => updateCarouselState({imageNo, isOpen: true})}
    >
      <S.CaptivateCardImage src={thumbnailUrl || imgUrl} width={'100%'} />
      <HappyPlayIcon />
    </S.VideoLandscapeImageWrapper>
  ) : (
    <S.CaptivateCardImage
      src={imgUrl}
      onClick={() => updateCarouselState({imageNo, isOpen: true})}
    />
  );
};

export default CaptivateCardImage;
